
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";

import {
  DeepLoop
} from '@/common/deepLoop/deepLoop'

import { PlatformPosterManageAPI } from "@/common/api/userManage/platformPosterManage";
import { CommonApi } from "@/common/api/common";

import {
  getCommonList
} from '@/common/config'

// import { excuteDownloadExport2Excel } from "@/common/xlsx";
export const pageApiList = getPageAPIs(PlatformPosterManageAPI);

import {
  shareConfirmOptions,
  // transferUserLevel2ch,
  defaultUserMemberList,
} from "@/common/config";


// 分类:1普通话2方言
// const platformPosterCategory2Ch: string[] = ['', '普通话', '方言']

// 状态：1上架，2下架
// const platformPosterStatus2Ch: string[] = ['', '上架', '下架']


// const defaultForms: any = {
//   name: '',
//   remark: '',
//   cover_pic_id: '',
//   cover_pic_url: '',
//   info_pic_id: '',
//   info_pic_url: '',
//   light_pack_id: '',
//   light_pack_url: '',
//   status: 1, // 状态：1上架，2下架
// }

const platformPosterDialogTitle2ch: any = {
  "new-platform-poster": "新增平台海报",
  "edit-platform-poster": "编辑平台海报",
};

@Component({
  filters: {
    // showPlatformPosterCategoryName(category: number) {
    //   return platformPosterCategory2Ch[category] || ''
    // },

    // showPlatformPosterStatusName(status: number) {
    //   return platformPosterStatus2Ch[status] || ''
    // }
  }
})
export default class PlatformPoster extends Vue {
  private utilInstance: any;
  private platformPosterManageApi: any;

  private commonApi: any;

  private deepLoopUtil: any = {};

  // private get isEditPulished() {
  //   const mode = this.platformPosterDialogMode
  //   const currentPlatformPosterManageItem = this.currentPlatformPosterManageItem

  //   console.log(mode, 'mode')


  //   return mode == 'edit-platform-poster' &&  (currentPlatformPosterManageItem &&currentPlatformPosterManageItem.is_publish == 1)
  // }


  constructor() {
    super();
    this.platformPosterManageApi = new PlatformPosterManageAPI();

    this.commonApi = new CommonApi();

    this.deepLoopUtil = new DeepLoop();

    this.utilInstance = new Util();

    // this.forms = {
    //   ...DeepLoop.deepClone(defaultForms)
    // }

    // 封禁时间列表
    // this.all_forbidden_time_list = Util.getFoibiddenTimeList();
  }

  private firstLoading: boolean = true;

  // private platformPosterCategoryList: any[] = [
  //   ...getCommonList(platformPosterCategory2Ch, 1)
  // ]

  private form: any = {
    // name: "", // 名称
  };

  private activated(): void {
    this.getTable();
  }
  private getTable(): void {
    this.platformPosterManageApi.getPlatformPosterTableList(
      this.getPlatformPosterTableListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      }
    );
  }

  private getPlatformPosterTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      // userName, // 用户昵称
      // name, // 名称
      // userLevel, // 会员等级
      // invite_code, // 邀请码
      // time, // 时间选择
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {};

    // if (name) {
    //   outerParams.name = name;
    // }
    // if (Array.isArray(time) && time.length === 2) {
    //   const [startDate, endDate] = time;

    //   const startTime = Util.dateTimeUtilnohms(startDate);
    //   const endTime = Util.dateTimeUtilnohms(endDate);

    //   outerParams.created_start_time = startTime;

    //   outerParams.created_end_time = endTime;
    // }

    // if (
    //   mode == "exportExcel" &&
    //   !(outerParams.created_start_time && outerParams.created_end_time)
    // ) {
    //   this.$message.error("请选择时段导出数据");
    //   return null;
    // }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  private imagePicUploading: boolean = false
  private onUploadAddPlatformPoster(file: any, fileList: any[]) {
    console.log(file, fileList, "file", "fileList");

    this.imagePicUploading = true;
    this.commonApi.getOss(
      file instanceof File ? file : file.raw,
      (res: any) => {
        console.log(res, "res 图片上传成功");

        const { data } = res;

        const { data: callbackData } = data;

        const { item: uploadImgObj } = callbackData || {};

        const { id, url } = uploadImgObj;

        this.platformPosterManageApi.addPlatformPoster({
          id
        }, (res: any) => {
          this.$message.success("海报上传成功");
          this.imagePicUploading = false;

          this.getTable();
        }, (err: any) => {
          console.log(err, 'err')
          this.imagePicUploading = false;
        })
      },
      () => {
        this.$message.error("海报上传失败");

        this.imagePicUploading = false;
      }
    );
  }

  // private imageInfoPicUploading: boolean = false
  // private handleUploadInfoImagePic(file: any, fileList: any[]) {
  //   console.log(file, fileList, "file", "fileList");

  //   this.imageInfoPicUploading = true;
  //   this.commonApi.getOss(
  //     file instanceof File ? file : file.raw,
  //     (res: any) => {
  //       console.log(res, "res 图片上传成功");

  //       const { data } = res;

  //       const { data: callbackData } = data;

  //       const { item: uploadImgObj } = callbackData || {};

  //       const { id, url } = uploadImgObj;

  //       this.$set(this.forms, "info_pic_id", id);
  //       this.$set(this.forms, "info_pic_url", url);

  //       this.imageInfoPicUploading = false;
  //     },
  //     () => {
  //       this.$message.error("图片上传失败");

  //       this.imageInfoPicUploading = false;
  //     }
  //   );
  // }

  // private imagePicUploading: boolean = false
  // private handleUploadLeagueImagePic(file: any, fileList: any[]) {
  //   console.log(file, fileList, "file", "fileList");

  //   this.imagePicUploading = true;
  //   this.commonApi.getOss(
  //     file instanceof File ? file : file.raw,
  //     (res: any) => {
  //       console.log(res, "res 图片上传成功");

  //       const { data } = res;

  //       const { data: callbackData } = data;

  //       const { item: uploadImgObj } = callbackData || {};

  //       const { id, url } = uploadImgObj;

  //       this.$set(this.forms, "cover_pic_id", id);
  //       this.$set(this.forms, "cover_pic_url", url);

  //       this.imagePicUploading = false;
  //     },
  //     () => {
  //       this.$message.error("图片上传失败");

  //       this.imagePicUploading = false;
  //     }
  //   );
  // }

  // private upFileloading: boolean = false

  // private upfileList: any[] = []

  // private handleCustomFileUploadFile(file: any) {
  //   this.upFileloading = true;
  //   this.commonApi.getOssLimitIntNameFile(
  //     file instanceof File ? file : file.raw,
  //     (res: any) => {
  //       console.log(res, "res 文件上传成功");

  //       const { data } = res;

  //       const { data: uploadFileObj } = data || {};

  //       const { item: uploadFile } = uploadFileObj || {};

  //       const { id, url, file_name } = uploadFile || {};

  //       this.$set(this.forms, 'light_pack_id', id)
  //       this.$set(this.forms, 'light_pack_url', file_name || url)

  //       this.upfileList.push({
  //         id,
  //         url: file_name || url
  //       })

  //       console.log(this.forms, 'forms')

  //       this.upFileloading = false;
  //     },
  //     (err: any) => {
  //       const {
  //         errMsg = ''
  //       } = err || {}

  //       this.$message.error(errMsg || "文件上传失败");

  //       this.upFileloading = false;
  //     },
  //   );
  // }

  // private onFileRemove(file: any) {
  //   const upfileList = this.upfileList

  //   const existFileIndex = upfileList.findIndex((eachFile) => eachFile.id == file.id)

  //   if (existFileIndex > -1) {
  //     this.upfileList.splice(existFileIndex, 1)

  //     this.$set(this.forms, 'light_pack_id', '')
  //     this.$set(this.forms, 'light_pack_url', '')
  //   }
  // }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const {} = data;

    const newData = {
      ...data,
    };

    return newData;
  }

  // 发布平台海报
  private onPulishPlatformPoster(platformPosterItem: any): void {
    console.log(platformPosterItem, "platformPosterItem");

    const { id } = platformPosterItem || {};

   this.$confirm("确认发布该平台海报吗？", "", {
      ...shareConfirmOptions,
    }).then(() => {
      this.platformPosterManageApi.pulishPlatformPoster(
          {
            id,
          },
          () => {
            this.$message.success("发布成功");
            this.getTable();
          }
      );
    });
  }

  private onDeletePlatformPosterManage(platformPosterItem: any): void {
    console.log(platformPosterItem, "platformPosterItem");

    const { id } = platformPosterItem || {};

   this.$confirm("确认删除该平台海报吗？", "", {
      ...shareConfirmOptions,
    }).then(() => {
      this.platformPosterManageApi.delPlatformPoster(
          {
            id,
          },
          () => {
            this.$message.success("删除成功");
            this.getTable();
          }
      );
    });
  }


  // 平台海报管理
  // private changePlatformPosterLoading: boolean = false

  // private addOrUpdatePlatformPosterManageTitle: string = "平台海报";

  // private platformPosterDialogMode: string = "";

  // private currentPlatformPosterManageItem: any = null;

  // private dialogFormVisible: boolean = false

  // private forms: any = {}
  // private onWakePlatformPosterDialog(mode: string) {
  //   this.platformPosterDialogMode = mode;
  //   this.addOrUpdatePlatformPosterManageTitle =
  //     platformPosterDialogTitle2ch[mode] || "平台海报";

  //   this.initPlatformPosterManageForm(mode);

  //   this.dialogFormVisible = true;
  // }

  //  private async initPlatformPosterManageForm(mode: string) {
  //   const forms: any = {
  //     ...this.deepLoopUtil.deepCopy(defaultForms, false),
  //   };

  //   this.upfileList = []


  //   if (mode == "edit-platform-poster") {
  //     const currentPlatformPosterManageItem = this.currentPlatformPosterManageItem;

  //     const {
  //       id,
  //       name = '',
  //       cover_pic_id = '',
  //       cover_pic_url = '',
  //       info_pic_id = '',
  //       info_pic_url = '',
  //       light_pack_id = '',
  //       light_pack_oss_url = '',
  //       file_name = '',
  //       status,
  //     } = currentPlatformPosterManageItem || {};

  //     Object.assign(forms, {
  //       name,
  //       cover_pic_id,
  //       cover_pic_url,
  //       info_pic_id,
  //       info_pic_url,
  //       light_pack_id,
  //       light_pack_url: file_name || light_pack_oss_url,
  //       status
  //     });


  //     this.upfileList = [{
  //       id: light_pack_id,
  //       url: file_name || light_pack_oss_url
  //     }]


  //     forms.id = id;
  //   }

  //   console.log(forms, "forms");

  //   this.forms = forms;
  // }

  // private onWakeEditPlatformPosterManageDialog(platformPosterItem: any) {
  //   this.currentPlatformPosterManageItem = platformPosterItem;

  //   this.onWakePlatformPosterDialog("edit-platform-poster");
  // }

  // private getPlatformPosterParams(mode: string) {
  //   const forms = this.forms

  //   const showErrorMessage = (msg: string) => {
  //     if (!!msg) {
  //       this.$message.error(msg);
  //     }
  //   };

  //   const params: any = {}

  //   const {
  //     id,
  //     // light_pack_id,
  //   } = forms

  //   const keys = ["name", "cover_pic_id", "info_pic_id", "light_pack_id", "status"];

  //   const key2EndKey: any = {
  //     name: "name",
  //     cover_pic_id: "cover_pic_id",
  //     info_pic_id: "info_pic_id",
  //     light_pack_id: "light_pack_id",
  //     status: "status"
  //   };

  //   const key2ErrMsg: any = {
  //     name: "名称不能为空",
  //     cover_pic_id: "封面不能为空",
  //     info_pic_id: "详情页不能为空",
  //     light_pack_id: "平台海报压缩包不能为空",
  //     status: "状态不能为空"
  //   };

  //   for (let i = 0; i < keys.length; i++) {
  //     const key = keys[i];

  //     if (forms[key]) {
  //       const errMsg = key2ErrMsg[`${key}_${forms[key]}`];
  //       if (errMsg) {
  //         showErrorMessage(errMsg);

  //         return false;
  //       }
  //       params[key2EndKey[key] || key] = forms[key];
  //     } else {
  //       showErrorMessage(key2ErrMsg[key]);

  //       return false;
  //     }
  //   }

    
  //   if (mode == "edit-platform-poster") {
  //     params.id = id;
  //   }

    

  //   return params
  // }

  // private onConfirmPlatformPoster() {
  //   const platformPosterDialogMode = this.platformPosterDialogMode;

  //   const params = this.getPlatformPosterParams(platformPosterDialogMode)

  //   if (typeof params != 'object') return

  //   this.changePlatformPosterLoading = true
  //   switch (platformPosterDialogMode) {
  //     case "new-platform-poster":
  //       this.platformPosterManageApi.addPlatformPoster(
  //         params,
  //         () => {
  //           this.getTable();
  //           this.dialogFormVisible = false;
  //           this.changePlatformPosterLoading = false;
  //         },
  //         () => {
  //           this.changePlatformPosterLoading = false;
  //         }
  //       );
  //       break;
  //     case "edit-platform-poster":
  //       this.platformPosterManageApi.editPlatformPoster(
  //         params,
  //         () => {
  //           this.getTable();
  //           this.dialogFormVisible = false;
  //           this.changePlatformPosterLoading = false;
  //         },
  //         () => {
  //           this.changePlatformPosterLoading = false;
  //         }
  //       );
  //       break;
  //   }

   
  // }
 

  /** 导出excel */
  // private downloadExcelLoading: boolean = false;

  // // 用户字段名 文案对应关系
  // private userExcelList2ch: any = {
  //   id: "用户ID",
  //   user_name: "用户昵称",
  //   phone: "用户手机号",
  //   gender_name: "性别",
  //   invite_code: "邀请码",
  //   birthday: "生日",
  //   user_level_name: "会员等级",
  //   created_at: "注册时间",
  //   account_status_name: "账户状态",
  // };
  // // 用户Excel 表头的先后顺序
  // private userExcelSortList: string[] = [
  //   "id",
  //   "user_name",
  //   "phone",
  //   "gender_name",
  //   "invite_code",
  //   "birthday",
  //   "user_level_name",
  //   "created_at",
  //   "account_status_name",
  // ];

  // // 点击导出excel 表格
  // private handleDownloadExcel() {
  //   const params = this.getPlatformPosterTableListParams("exportExcel");

  //   if (params === null) {
  //     return false;
  //   }

  //   this.downloadExcelLoading = true;
  //   this.platformPosterManageApi.exportExcelUserList(
  //     params,
  //     (res: any) => {
  //       const { created_start_time, created_end_time } = params || {};

  //       const filename = `用户列表 ${created_start_time}到${created_end_time}.xlsx`;
  //       const { data } = res || {};

  //       const { list: originList } = data || {};

  //       const newList = Array.isArray(originList)
  //         ? originList.map((item) => {
  //             const { gender, type, status } = item;
  //             const newItem = {
  //               ...(item || {}),
  //             };

  //             // if (!forbidTime) {
  //             newItem.gender_name = this.transferGender2ch[gender];

  //             newItem.user_level_name = this.transferUserLevel2ch[type];

  //             newItem.account_status_name =
  //               this.transferUserAccountStatus2ch[status];
  //             // }

  //             return newItem;
  //           })
  //         : [];

  //       if (newList.length > 0) {
  //         const userExcelSortList = this.userExcelSortList;

  //         const userExcelList2ch = this.userExcelList2ch;

  //         const excelJSONData = getExcelJSONDataByList(
  //           newList,
  //           userExcelSortList,
  //           userExcelList2ch
  //         );

  //         excuteDownloadExport2Excel(excelJSONData, filename);
  //       } else {
  //         this.$message.info("选中时段没有可导出的信息");
  //       }

  //       this.downloadExcelLoading = false;
  //     },
  //     () => {
  //       this.downloadExcelLoading = false;
  //     }
  //   );
  // }

  /** end 导出excel */

  private restForm(): void {
    this.form = this.utilInstance.clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
